import React from 'react';
import bannerImage from '../assets/heda_banner_4.jpg';

function Banner({ title }) {
  return (
    <div
      className="relative h-[105px] md:h-[140px] w-full flex items-center justify-center cursor-pointer"
      style={{
        backgroundImage: `url(${bannerImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* 半透明遮罩層，讓文字更清楚，也不擋 click */}
      <div className="absolute inset-0 bg-black/30 pointer-events-none"></div>

      {/* 文字 */}
      <h1 className="relative z-10 text-3xl md:text-4xl font-ec text-white text-center pointer-events-none">
        {title}
      </h1>
    </div>
  );
}

export default Banner;
